<template>
  <div>

    <div class="space-sm"></div>

    <div class="container-full">

      <div class="grid-12">
        <div class="grid-12 padding-sm box">
          <form @submit.stop.prevent="getLeads">
            <div class="grid-3 padding-sm">
              <label class="form-label">Franquia</label>
              <select class="form-field" v-model="franchise">
                <option v-for="franchise in franchises" :value="franchise['slug']" v-bind:key="franchise['slug']">{{franchise['nome']}}</option>
              </select>
            </div>
            <div class="grid-3 padding-sm">
              <label class="form-label">Data Inicial</label>
              <input type="date" class="form-field" v-model="dateStart">
            </div>
            <div class="grid-3 padding-sm">
              <label class="form-label">Data Final</label>
              <input type="date" class="form-field" v-model="dateEnd">
            </div>
            <div class="break"></div>
            <div class="grid-3 padding-sm">
              <button class="button button-full">Buscar</button>
            </div>
            <div class="grid-3 padding-sm" v-if="!loading.excel">
              <button @click="downloadExcel" type="button" class="button button-full">Download Excel</button>
            </div>
            <div class="grid-3" v-if="loading.excel">
              <i class="fas fa-spinner fa-spin"></i> Gerando Excel...
            </div>
          </form>
        </div>
      </div>

      <div class="grid-12">
        <div class="grid-12 no-padding box">

          <div class="grid-12" v-if="loading.leads">
            <i class="fas fa-spinner fa-spin"></i> Carregando leads...
          </div>

          <div class="grid-12" v-if="!loading.leads">
            <table class="table">
              <thead>
                <tr>
                  <td>NOME</td>
                  <td>IDADE</td>
                  <td>TELEFONE</td>
                  <td>CURSO</td>
                  <td>DATA</td>
                  <td>FONTE</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="lead in leads" v-bind:key="lead.name">
                  <td>{{lead.name}}</td>
                  <td>{{lead.age}}</td>
                  <td>{{lead.phone}}</td>
                  <td>{{lead.course}}</td>
                  <td>{{lead.date}}</td>
                  <td>{{lead.source}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    name: 'files',
    data() {
      return {
        dateStart: null,
        dateEnd: null,
        franchise: null,
        franchises: [],
        leads: null,
        loading: {
          leads: false,
          excel: false
        }
      }
    },
    methods: {
      getLeads() {
        this.loading.leads = true;
        var self = this;
        var data = new FormData();
        if (this.dateStart) {
          data.append('dateStart', this.dateStart);
        } 
        if (this.dateEnd) {
          data.append('dateEnd', this.dateEnd);
        }
        data.append('franchise', this.franchise);
        data.append('auth_code',  this.$store.state.login.auth_code);
        axios
          .post(process.env.VUE_APP_API + "/get_leads.php", data)
          .then(function (response) {
            self.loading.leads = false;
            self.leads = response.data.leads;
          })
          .catch(function (error) {
            self.loading.leads = false;
          });
      },
      getFranchises() {
        var self = this;
        var data = new FormData();
        data.append('auth_code',  this.$store.state.login.auth_code);
        axios
          .post(process.env.VUE_APP_API + "/get_franchises.php", data)
          .then(function (response) {
            console.log(response.data.franchises);
            self.franchises = response.data.franchises;
          })
      },
      downloadExcel(){
        this.loading.excel = true;
        var self = this;
        var data = new FormData();
        if (this.dateStart) {
          data.append('dateStart', this.dateStart);
        } 
        if (this.dateEnd) {
          data.append('dateEnd', this.dateEnd);
        }
        data.append('franchise', this.franchise);
        data.append('auth_code',  this.$store.state.login.auth_code);
        axios
        .post(process.env.VUE_APP_API + "/excel_leads.php", data)
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'leads.xls')
          document.body.appendChild(link)
          link.click()
          self.loading.excel = false;
        })
      }
    },
    mounted() {
      this.getFranchises();
    },
    watch: {
      $route() {
        this.getFranchises();
      }
    }
  }
</script>